import { render, staticRenderFns } from "./DonutStatCard.vue?vue&type=template&id=06cb53dd&scoped=true&"
import script from "./DonutStatCard.vue?vue&type=script&lang=js&"
export * from "./DonutStatCard.vue?vue&type=script&lang=js&"
import style0 from "./DonutStatCard.vue?vue&type=style&index=0&id=06cb53dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb53dd",
  null
  
)

export default component.exports